module.exports = __webpack_public_path__ + "img/chart.2901a206.svg";